<template>
    <section class="tekst light purple">
        <circles-layout></circles-layout>
        <h1>Trots</h1>
        <p>Na een relatief rustig 2019, was 2020 een jaar om nooit te vergeten. Door de coronacrisis bevonden wij ons ineens in een onverwachte realiteit. De pandemie trok een behoorlijke wissel op het onderwijs. Vanaf half maart 2020 moest abrupt worden overgeschakeld naar (digitaal) afstandsonderwijs.</p>
        <p>Wij zijn enorm trots op al onze leerlingen en studenten. Ondanks het gemis van de studie- en klasgenoten en docenten zijn zij erin geslaagd om onderwijs te blijven volgen! We hebben ook enorme bewondering voor al onze medewerkers die deze uitdaging met veel energie en creativiteit zijn aangegaan en met volharding tot een succes hebben gebracht.</p>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
</style>

<script>
    import Circles from '@/app/components/circles';
    export default {
        name: 'OntwikkelingTrots',
        meta: {
            title: 'OntwikkelingTrots',
            color: '#a5147e'
        },
        components: {
            'circles-layout': Circles
        },
        methods: {
            focus()
            {
            }
        }
    };
</script>
